<template>
  <div v-show="isshow">
    <div class="m-popup-layer">
      <!--免费咨询-->
      <table class="m-popup-table">
        <tbody>
          <tr>
            <td>
              <div class="tip-content" @click.stop.prevent="">
                <p class="tip-title">提示信息</p>
                <p>{{ errorText }}</p>
                <p class="tip-btn">
                  <a @click="setVshow">我知道了</a>
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "tip",
  props: ["showBtn", "errortext"],
  data: function () {
    return {
      isshow: this.showBtn,
      errorText: this.errortext,
    };
  },
  methods: {
    setVshow: function () {
      this.isshow = false;
    },
  },
};
</script>
<style scoped="">
* {
  color: #666;
  font-size: 14px;
}
.tip-content {
  width: 335px;
  height: 207px;
  background-color: #fff;
  margin: 0 auto;
  z-index: 9999;
}
.tip-content p {
  text-align: center;
}
.tip-content .tip-title {
  padding-top: 50px;
  padding-bottom: 20px;
  font-size: 18px;
  color: #666666;
  line-height: 25px;
}
.tip-btn a {
  background: #f5f5f5;
  border: 1px solid #a28b77;
  font-size: 18px;
  color: #a28b77;
  display: inline-block;
  width: 167px;
  height: 44px;
  line-height: 44px;
  margin-top: 28px;
}
</style>



// WEBPACK FOOTER //
// tip-dialog.vue?d3741c5e